export default "__VITE_ASSET__15f6636c__"